import { ViewModalHeader } from './ViewModalHeader'
import '../estiloslogs.css'
import { object } from 'yup';

const API_URL = process.env.REACT_APP_API_URL

const ModalDetail = ( props:any ) => {
  const info = props.Info;

  const renderValue = (value: any): React.ReactNode => {
    if (Array.isArray(value)) {
      return value.map((item, index) => (
        <div key={index}>
          {typeof item === 'object' ? (
            Object.keys(item).map((subKey, subIndex) => (
              <div key={subIndex} className="sub-key-value-pair">
                <p className="sub-key f-parrafo" style={{ width: '100px' }}><strong>{subKey}:</strong></p>
                <p className="sub-value f-parrafo" style={{ width: '300px' }}>{item[subKey]}</p>
              </div>
            ))
          ) : (
            <p className="value f-parrafo">{item}</p>
          )}
          {typeof item === 'object' && <hr />}
        </div>
      ));
    } 
    else if (typeof value === 'object' && value !== null) {
      return Object.keys(value).map((innerKey, innerIndex) => (
        <div key={innerIndex} className="key-value-pair">
          <p className="key f-parrafo" style={{ width: '100px' }}><strong>{innerKey}:</strong></p>
          <p className="value f-parrafo" style={{ width: '200px' }}>{value[innerKey]}</p>
        </div>
      ));
    } else {
      return <p className="value f-parrafo">{value}</p>;
    }
  };

  return (
    
    <>
    {props.id !==null &&
    <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
     

                  {info&&Object.keys(info).map((key,index)=>(
                    <div key={index}>
                      <div className='tarjetas'>
                          <div className='card-info'>
                            <div className='card-info-header  f-parrafo'>
                              <h2 className='text-marino'>{key==='new'?'New Data':key==='old'?'Old Data':''}</h2>
                              <div className={`fs-8 fw-bold ${props.typeChange===1?'text-success':props.typeChange===2?'text-azul':props.typeChange===3?'text-danger':''}` } >Change Type: {props.typeChange===1?<span className="badge badge-light-success ">Create</span>:props.typeChange===2?<span className="badge badge-light-azul">Update</span>:props.typeChange===3?<span className="badge badge-danger">Delete</span>:'---'}</div>
                            </div>
                            <div className='card-info-content'>
                              {Object.keys(info[key]).length!==0&&Object.keys(info[key]).map((innerKey, innerIndex) => (
                                <div key={innerIndex} className="key-value-pair">
                                  <p className="key f-parrafo" style={{ width: '100px' }}><strong>{innerKey}:</strong></p>
                                  <div className="value f-parrafo" style={{ width: '200px' }}>
                                    {renderValue(info[key][innerKey])}
                                  </div>                                
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <br />
                    </div>
                  ))

                  }
                 
               

                  {/* begin::Heading */}          
                            
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }


     
    </>
  )
}
export {ModalDetail}